import { getFaces, deleteFaces } from '@vlabs/api/luna-api/client';

import type { FaceId } from '@vlabs/api/luna-api/model';

export async function deleteAllFacesFromList(id: string): Promise<void> {
  const pageSize = 1000;

  while (true) {
    // eslint-disable-next-line no-await-in-loop
    const facesResponse = await getFaces({
      list_id: id,
      targets: ['face_id'],
      page_size: pageSize,
    });

    const faceIds = facesResponse.faces?.map(({ face_id }) => face_id) ?? [];

    if (!faceIds.length) {
      break;
    }

    // eslint-disable-next-line no-await-in-loop
    await deleteFaces({
      face_ids: faceIds as FaceId[],
    }, { ignore: 1 });

    if (faceIds.length < pageSize) {
      break;
    }
  }
}
